import { useState, useCallback } from 'react';

/**
 * Hook for browser Geolocation API.
 * Returns lat/lon/accuracy/error and a requestLocation function.
 */
export function useGeolocation() {
  const [position, setPosition] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const requestLocation = useCallback(() => {
    if (!navigator.geolocation) {
      setError('Geolocation wird von diesem Browser nicht unterstützt.');
      return;
    }

    setLoading(true);
    setError(null);

    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setPosition({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracy: pos.coords.accuracy,
        });
        setLoading(false);
      },
      (err) => {
        const messages = {
          1: 'Standortzugriff verweigert. Bitte erlaube den Zugriff in deinen Browsereinstellungen.',
          2: 'Standort konnte nicht ermittelt werden.',
          3: 'Zeitüberschreitung bei der Standortermittlung.',
        };
        setError(messages[err.code] || 'Unbekannter Fehler.');
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000, // 5 min cache
      }
    );
  }, []);

  return { position, loading, error, requestLocation };
}
